import { render, staticRenderFns } from "./Detail_V2.vue?vue&type=template&id=08fe26d4&scoped=true&"
import script from "./Detail_V2.vue?vue&type=script&lang=js&"
export * from "./Detail_V2.vue?vue&type=script&lang=js&"
import style0 from "./Detail_V2.vue?vue&type=style&index=0&id=08fe26d4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08fe26d4",
  null
  
)

export default component.exports